<template>
	<section class="sec-main-banner">
		<div class="container-box">
			<div :class="['banner', 'banner-01', { mobile: isMobile }]">
				<h2>
					{{ $t('new_ui.home_page_v2.section_main_banner.title.one') }}
					{{ $t('new_ui.home_page_v2.section_main_banner.title.two') }}<br />
					{{ $t('new_ui.home_page_v2.section_main_banner.title.three') }}

					{{ $t('new_ui.home_page_v2.section_main_banner.title.four') }}<br />
					{{ $t('new_ui.home_page_v2.section_main_banner.title.five') }}
					{{ $t('new_ui.home_page_v2.section_main_banner.title.six') }}
				</h2>
				<p>
					{{ $t('new_ui.home_page_v2.section_main_banner.description.one')
					}}<br />
					{{ $t('new_ui.home_page_v2.section_main_banner.description.two') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_main_banner.description.three') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_main_banner.description.four') }}
				</p>
				<a href="/auth/register">
					{{ $t('new_ui.home_page_v2.section_main_banner.cta_buttons.one') }}
				</a>
			</div>
		</div>
	</section>

	<section class="sec-safety-speed">
		<div class="container-box">
			<h3 class="title">
				{{ $t('new_ui.home_page_v2.section_safety_speed.title') }}
			</h3>
			<div :class="['card-box', { mobile: isMobile }]">
				<div class="card-content card-content-01">
					<div v-if="!isMobile" class="cover">
						<img :src="img.imgSafetySpeedCover01" alt="" />
					</div>
					<img
						:src="img.iconSafeAlert"
						alt=""
						:style="isMobile ? { width: '60px', height: '60px' } : {}"
					/>
					<h4>
						{{ $t('new_ui.home_page_v2.section_safety_speed.cards.one.title') }}
					</h4>
					<p>
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.one.description.one',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.one.description.two',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.one.description.three',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.one.description.four',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.one.description.five',
							)
						}}
					</p>
					<a href="/auth/register">
						{{ $t('new_ui.home_page_v2.section_safety_speed.cta_button') }}
						<img :src="img.iconArrowRightWhite" alt="" />
					</a>
				</div>
				<div class="card-content card-content-02">
					<div v-if="!isMobile" class="cover">
						<img :src="img.imgSafetySpeedCover02" alt="" />
					</div>
					<img
						:src="img.iconPaper"
						alt=""
						:style="isMobile ? { width: '60px', height: '60px' } : {}"
					/>
					<h4>
						{{ $t('new_ui.home_page_v2.section_safety_speed.cards.two.title') }}
					</h4>
					<p>
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.two.description.one',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.two.description.two',
							)
						}}
					</p>
					<a href="/auth/register">
						{{ $t('new_ui.home_page_v2.section_safety_speed.cta_button') }}
						<img :src="img.iconArrowRightWhite" alt="" />
					</a>
				</div>
				<div class="card-content card-content-03">
					<div v-if="!isMobile" class="cover">
						<img :src="img.imgSafetySpeedCover03" alt="" />
					</div>
					<img
						:src="img.iconCard"
						alt=""
						:style="isMobile ? { width: '60px', height: '60px' } : {}"
					/>
					<h4>
						{{
							$t('new_ui.home_page_v2.section_safety_speed.cards.three.title')
						}}
					</h4>
					<p>
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.three.description.one',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.three.description.two',
							)
						}}
						<br />
						{{
							$t(
								'new_ui.home_page_v2.section_safety_speed.cards.three.description.three',
							)
						}}
					</p>
					<a href="/auth/register">
						{{ $t('new_ui.home_page_v2.section_safety_speed.cta_button') }}
						<img :src="img.iconArrowRightWhite" alt="" />
					</a>
				</div>
			</div>
		</div>
	</section>
	<section class="sec-use">
		<div class="container-box">
			<h3 class="title">
				{{ $t('new_ui.home_page_v2.section_use.title') }}
			</h3>
			<div :class="['card-box', { mobile: isMobile }]">
				<div class="card-content card-content-01">
					<div class="txt">
						<h5>
							{{ $t('new_ui.home_page_v2.section_use.cards.one.title') }}
						</h5>
						<p>
							{{ $t('new_ui.home_page_v2.section_use.cards.one.description') }}
						</p>
					</div>
					<img :src="img.iconUse01" alt="" />
				</div>
				<div class="card-content card-content-02">
					<div class="txt">
						<h5>
							{{ $t('new_ui.home_page_v2.section_use.cards.two.title') }}
						</h5>
						<p>
							{{ $t('new_ui.home_page_v2.section_use.cards.two.description') }}
						</p>
					</div>
					<img :src="img.iconUse02" alt="" />
				</div>
				<div class="card-content card-content-03">
					<div class="txt">
						<h5>
							{{ $t('new_ui.home_page_v2.section_use.cards.three.title') }}
						</h5>
						<p>
							{{
								$t('new_ui.home_page_v2.section_use.cards.three.description')
							}}
						</p>
					</div>
					<img :src="img.iconUse03" alt="" />
				</div>
			</div>
		</div>
	</section>
	<section class="sec-free">
		<div class="bg-01"></div>
		<div class="bg-02"></div>
		<div class="bg-03"></div>
		<div class="container-box">
			<div class="title-box">
				<strong class="title-point">
					{{ $t('new_ui.home_page_v2.section_free.title_point') }}
				</strong>
				<h3 class="title">
					{{ $t('new_ui.home_page_v2.section_free.title') }}
				</h3>
				<p class="title-description">
					<strong>{{
						$t('new_ui.home_page_v2.section_free.title_description.one')
					}}</strong>
					{{ $t('new_ui.home_page_v2.section_free.title_description.two') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_free.title_description.three') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_free.title_description.four') }}
				</p>
			</div>
			<div :class="['card-box', { mobile: isMobile }]">
				<div class="card-content card-content-01">
					<img :src="img.imgFree01" alt="" />
					<h4>
						{{ $t('new_ui.home_page_v2.section_free.cards.one.title') }}
					</h4>
					<p>
						{{ $t('new_ui.home_page_v2.section_free.cards.one.description.one')
						}}<br />
						{{
							$t('new_ui.home_page_v2.section_free.cards.one.description.two')
						}}
					</p>
				</div>
				<div class="card-content card-content-02">
					<img :src="img.imgFree02" alt="" />
					<h4>
						{{ $t('new_ui.home_page_v2.section_free.cards.two.title') }}
					</h4>
					<p>
						{{ $t('new_ui.home_page_v2.section_free.cards.two.description.one')
						}}<br />
						{{
							$t('new_ui.home_page_v2.section_free.cards.two.description.two')
						}}
					</p>
				</div>
				<div class="card-content card-content-03">
					<img :src="img.imgFree03" alt="" />
					<h4>
						{{ $t('new_ui.home_page_v2.section_free.cards.three.title') }}
					</h4>
					<p>
						{{
							$t(
								'new_ui.home_page_v2.section_free.cards.three.description.one',
							)
						}}<br />
						{{
							$t('new_ui.home_page_v2.section_free.cards.three.description.two')
						}}
					</p>
				</div>
			</div>
			<a href="/auth/register">
				{{ $t('new_ui.home_page_v2.section_free.button') }}
				<img :src="img.iconArrowRightBlue" alt="" />
			</a>
		</div>
	</section>
	<section class="sec-world">
		<div :class="['container-box', { mobile: isMobile }]">
			<img :src="img.imgWorld" alt="" />
			<div class="title-box">
				<strong class="title-point">
					{{ $t('new_ui.home_page_v2.section_world.title_point') }}
				</strong>
				<h3 class="title">
					{{ $t('new_ui.home_page_v2.section_world.title.one') }}<br />
					{{ $t('new_ui.home_page_v2.section_world.title.two') }}
				</h3>
				<p class="title-description">
					{{ $t('new_ui.home_page_v2.section_world.title_description.one') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_world.title_description.two') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_world.title_description.three') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_world.title_description.four') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_world.title_description.five') }}
				</p>
				<a href="/auth/register">
					{{ $t('new_ui.home_page_v2.section_world.button') }}
					<img :src="img.iconArrowRightBlue" alt="" />
				</a>
			</div>
		</div>
	</section>
	<section class="sec-member">
		<div class="container-box">
			<div class="title-box">
				<strong class="title-point">
					{{ $t('new_ui.home_page_v2.section_member.title_point') }}
				</strong>
				<h3 class="title">
					{{ $t('new_ui.home_page_v2.section_member.title') }}
				</h3>
				<p class="title-description">
					{{ $t('new_ui.home_page_v2.section_member.title_description.one') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_member.title_description.two') }}
					<br />
					{{ $t('new_ui.home_page_v2.section_member.title_description.three') }}
				</p>
			</div>
			<a href="/auth/register">
				{{ $t('new_ui.home_page_v2.section_member.button') }}
				<img :src="img.iconArrowRightWhite" alt="" />
			</a>
		</div>
	</section>
</template>
<script>
import iconSafeAlert from '@/assets/images/v2/icon/icon-safe-alert.svg';
import iconPaper from '@/assets/images/v2/icon/icon-paper.svg';
import iconCard from '@/assets/images/v2/icon/icon-card.svg';
import imgSafetySpeedCover01 from '@/assets/images/v2/bg-safety-speed-01.png';
import imgSafetySpeedCover02 from '@/assets/images/v2/bg-safety-speed-02.png';
import imgSafetySpeedCover03 from '@/assets/images/v2/bg-safety-speed-03.png';
import iconArrowRightWhite from '@/assets/images/v2/icon/icon-arrow-right-white.svg';
import iconArrowRightBlue from '@/assets/images/v2/icon/icon-arrow-right-blue.svg';
import iconUse01 from '@/assets/images/v2/icon/icon-use-01.svg';
import iconUse02 from '@/assets/images/v2/icon/icon-use-02.svg';
import iconUse03 from '@/assets/images/v2/icon/icon-use-03.svg';
import imgFree01 from '@/assets/images/v2/img-free-01.png';
import imgFree02 from '@/assets/images/v2/img-free-02.png';
import imgFree03 from '@/assets/images/v2/img-free-03.png';
import imgWorld from '@/assets/images/v2/img-world.png';

import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);
export default {
	data: () => {
		return {
			mobile: window.innerWidth <= 768,
			img: {
				iconSafeAlert: iconSafeAlert,
				imgSafetySpeedCover01: imgSafetySpeedCover01,
				imgSafetySpeedCover02: imgSafetySpeedCover02,
				imgSafetySpeedCover03: imgSafetySpeedCover03,
				iconArrowRightWhite: iconArrowRightWhite,
				iconArrowRightBlue: iconArrowRightBlue,
				iconUse01: iconUse01,
				iconUse02: iconUse02,
				iconUse03: iconUse03,
				imgFree01: imgFree01,
				imgFree02: imgFree02,
				imgFree03: imgFree03,
				imgWorld: imgWorld,
				iconPaper: iconPaper,
				iconCard: iconCard,
			},
			swiperOptions: {
				slidesPerView: 2,
				spaceBetween: 10,
				navigation: false,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);

		const styleTag = document.getElementById('custom-style');
		if (styleTag) {
			styleTag.disabled = true;
		}
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);

		const styleTag = document.getElementById('custom-style');
		if (styleTag) {
			styleTag.disabled = false;
		}
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
	},
};
</script>
